import styled from 'styled-components';
import device from '../../../styles/mediaSizes';

export const StyledAccurateTesting = styled.div`
  .rn-section-gap {
    padding: 240px 0 !important;
    @media ${device.md} {
      padding: 80px 0 !important;
    }
    @media ${device.sm} {
      padding: 60px 0 !important;
    }
  }

  .section-title-wrapper {
    margin-bottom: 105px;
    .title {
      color: white;
      text-align: center;
      margin-bottom: 15px;
    }
    .subtitle {
    }
    .description {
      color: #fff;
      font-weight: 400;
      text-align: center;
    }

    @media ${device.lg} {
      & {
        margin-bottom: 75px;
        .heading-1,
        .heading-2 {
          text-align: center;
          margin-bottom: 15px;
        }
        .heading-4 {
          text-align: center;
        }
        .text-block-2 {
          margin: 0 auto;
          text-align: center;
          width: 80%;
        }
      }
    }
    @media ${device.md} {
      & {
        margin-bottom: 55px;
        .heading-1,
        .heading-2 {
        }
        .heading-4 {
        }
        .text-block-2 {
        }
      }
    }
    @media ${device.sm} {
      & {
        margin-bottom: 35px;
        .heading-1 {
          font-size: 38px;
          text-align: center;
          margin-bottom: 15px;
        }
        .heading-2 {
          text-align: center;
          margin-bottom: 15px;
        }
        .heading-4 {
          text-align: center;
        }
        .text-block-2 {
          margin: 0 auto;
          text-align: center;
          width: 100%;
        }
      }
    }
  }

  .cards-wrapper {
    display: flex;
    justify-content: center;
    gap: 10%;
    padding: 0;
    .card-item {
      position: relative;
      width: 27%;
      display: flex;
      height: 400px;
      background-color: #1f4a7f;
      border-radius: calc(9 * 1px);
      overflow: hidden;
      text-decoration: none;
      border: 2px solid #0778db00;
      transition: 0.5s;
      &:hover {
        border: 2px solid #0777db;
      }
      &:hover .card-header {
        background-color: #0777db;
      }
      &:hover .card-header .card-title-flipper-wrapper .card-title {
        opacity: 0;
      }
      &:hover .card-header .card-title-flipper-wrapper .card-title-flipper {
        opacity: 1;
      }
      .card-main-content {
        display: flex;
        justify-content: start;
        align-items: center;
        flex-direction: column;
        .card-image {
          display: block;
          padding-top: 25px;
          margin: 0 auto;
          width: 150px;
          height: 50%;
          object-fit: cover;
        }
        .card-main-text-group {
          padding: 0 15px;
          height: 10%;
          .card-main-title {
            color: #fff;
          }
          .card-main-description {
            color: #fff;
            font-size: 14px;
            font-weight: 200;
          }
        }
      }
      .card-header {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1.5em;
        padding: 2em;
        width: 100%;
        background-color: #265c9f;
        opacity: 1;
        transform: translateY(-100%);
        transition: 0.5s ease-in-out;
        .card-arc {
          display: none;
        }
        img {
          display: none;
        }
        .card-title-flipper-wrapper {
          position: relative;
          width: 100%;
          margin: 0 auto;
          .card-title,
          .card-title-flipper {
            text-align: center;
            font-size: 1.5em;
            margin: 0 0 0.1em;
            color: #fff;
            transition: 0.2s opacity;
          }
          .card-title {
            width: 100%;
            opacity: 1;
          }
          .card-title-flipper {
            position: absolute;
            right: 0;
            left: 0;
            top: 0;
            opacity: 0;
          }
        }
      }
      .card-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 0;
        z-index: 1;
        background-color: #fff;
        transform: translateY(100%);
        transition: 0.2s ease-in-out;
        .card-description {
          padding: 1em 1em 3em;
          margin: 0;
          overflow: hidden;
        }
      }
    }

    @media ${device.lg} {
      & {
        display: flex;
        justify-content: center;
        gap: 10%;
        padding: 0;
        .card-item {
          position: relative;
          width: 40%;
          display: flex;
          height: 430px;
          background-color: #1f4a7f;
          border-radius: calc(9 * 1px);
          overflow: hidden;
          text-decoration: none;
          border: 2px solid #0778db00;
          transition: 0.5s;
          &:hover {
            border: 2px solid #0777db;
          }
          &:hover .card-header {
            background-color: #0777db;
          }
          &:hover .card-header .card-title-flipper-wrapper .card-title {
            opacity: 0;
          }
          &:hover .card-header .card-title-flipper-wrapper .card-title-flipper {
            opacity: 1;
          }
          .card-main-content {
            display: flex;
            justify-content: start;
            align-items: center;
            flex-direction: column;
            .card-image {
              display: block;
              padding-top: 25px;
              margin: 0 auto;
              width: 150px;
              height: 50%;
              object-fit: cover;
            }
            .card-main-text-group {
              padding: 0 15px;
              height: 10%;
              .card-main-title {
                color: #fff;
              }
              .card-main-description {
                color: #fff;
                font-size: 14px;
                font-weight: 200;
              }
            }
          }
          .card-header {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 1.5em;
            padding: 2em;
            width: 100%;
            background-color: #265c9f;
            opacity: 1;
            transform: translateY(-100%);
            transition: 0.5s ease-in-out;
            .card-arc {
              display: none;
            }
            img {
              display: none;
            }
            .card-title-flipper-wrapper {
              position: relative;
              width: 100%;
              margin: 0 auto;
              .card-title,
              .card-title-flipper {
                text-align: center;
                font-size: 1.5em;
                margin: 0 0 0.1em;
                color: #fff;
                transition: 0.2s opacity;
              }
              .card-title {
                width: 100%;
                opacity: 1;
              }
              .card-title-flipper {
                position: absolute;
                right: 0;
                left: 0;
                top: 0;
                opacity: 0;
              }
            }
          }
          .card-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 0;
            z-index: 1;
            background-color: #fff;
            transform: translateY(100%);
            transition: 0.2s ease-in-out;
            .card-description {
              padding: 1em 1em 3em;
              margin: 0;
              overflow: hidden;
            }
          }
        }
      }
    }

    @media ${device.md} {
      & {
        display: flex;
        justify-content: center;
        gap: 10%;
        padding: 0;
        .card-item {
          position: relative;
          width: 50%;
          display: flex;
          height: 380px;
          background-color: #1f4a7f;
          border-radius: calc(9 * 1px);
          overflow: hidden;
          text-decoration: none;
          border: 2px solid #0778db00;
          transition: 0.5s;
          &:hover {
            border: 2px solid #0777db;
          }
          &:hover .card-header {
            background-color: #0777db;
          }
          &:hover .card-header .card-title-flipper-wrapper .card-title {
            opacity: 0;
          }
          &:hover .card-header .card-title-flipper-wrapper .card-title-flipper {
            opacity: 1;
          }
          .card-main-content {
            display: flex;
            justify-content: start;
            align-items: center;
            flex-direction: column;
            .card-image {
              display: block;
              padding-top: 25px;
              margin: 0 auto;
              width: 120px;
              height: 50%;
              object-fit: cover;
            }
            .card-main-text-group {
              padding: 0 15px;
              height: 10%;
              .card-main-title {
                font-size: 16px;
                color: #fff;
              }
              .card-main-description {
                color: #fff;
                font-size: 14px;
                font-weight: 200;
              }
            }
          }
          .card-header {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 1.5em;
            padding: 2em;
            width: 100%;
            background-color: #265c9f;
            opacity: 1;
            transform: translateY(-100%);
            transition: 0.5s ease-in-out;
            .card-arc {
              display: none;
            }
            img {
              display: none;
            }
            .card-title-flipper-wrapper {
              position: relative;
              width: 100%;
              margin: 0 auto;
              .card-title,
              .card-title-flipper {
                text-align: center;
                font-size: 1.5em;
                margin: 0 0 0.1em;
                color: #fff;
                transition: 0.2s opacity;
              }
              .card-title {
                width: 100%;
                opacity: 1;
              }
              .card-title-flipper {
                position: absolute;
                right: 0;
                left: 0;
                top: 0;
                opacity: 0;
              }
            }
          }
          .card-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 0;
            z-index: 1;
            background-color: #fff;
            transform: translateY(100%);
            transition: 0.2s ease-in-out;
            .card-description {
              padding: 1em 1em 3em;
              margin: 0;
              overflow: hidden;
            }
          }
        }
      }
    }

    @media ${device.sm} {
      & {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 0;
        padding: 0;
        .card-item {
          position: relative;
          margin-bottom: 35px;
          width: 90%;
          display: flex;
          height: 350px;
          background-color: #1f4a7f;
          border-radius: calc(9 * 1px);
          overflow: hidden;
          text-decoration: none;
          border: 2px solid #0778db00;
          transition: 0.5s;
          &:last-child{
            margin-bottom: 0;
          }
          &:hover {
            border: 2px solid #0777db;
          }
          &:hover .card-header {
            background-color: #0777db;
          }
          &:hover .card-header .card-title-flipper-wrapper .card-title {
            opacity: 0;
          }
          &:hover .card-header .card-title-flipper-wrapper .card-title-flipper {
            opacity: 1;
          }
          .card-main-content {
            display: flex;
            justify-content: start;
            align-items: center;
            flex-direction: column;
            .card-image {
              display: block;
              padding-top: 25px;
              margin: 0 auto;
              width: 120px;
              height: 50%;
              object-fit: cover;
            }
            .card-main-text-group {
              padding: 0 15px;
              height: 10%;
              .card-main-title {
                font-size: 16px;
                color: #fff;
              }
              .card-main-description {
                color: #fff;
                font-size: 12px;
                font-weight: 200;
              }
            }
          }
          .card-header {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 1.5em;
            padding: 1em;
            font-size: 1em;
            width: 100%;
            background-color: #265c9f;
            opacity: 1;
            transform: translateY(-100%);
            transition: 0.5s ease-in-out;
            .card-arc {
              display: none;
            }
            img {
              display: none;
            }
            .card-title-flipper-wrapper {
              position: relative;
              width: 100%;
              margin: 0 auto;
              .card-title,
              .card-title-flipper {
                text-align: center;
                font-size: 1.5em;
                margin: 0 0 0.1em;
                color: #fff;
                transition: 0.2s opacity;
              }
              .card-title {
                width: 100%;
                opacity: 1;
              }
              .card-title-flipper {
                position: absolute;
                right: 0;
                left: 0;
                top: 0;
                opacity: 0;
              }
            }
          }
          .card-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 0;
            z-index: 1;
            background-color: #fff;
            transform: translateY(100%);
            transition: 0.2s ease-in-out;
            .card-description {
              padding: 1em 1em 3em;
              margin: 0;
              overflow: hidden;
            }
          }
        }
      }
    }
  }

  .divider-wrapper {
    margin-bottom: 50px;
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    .divider-line-group {
      width: 100%;
      .divider-line-1 {
        position: relative;
        margin: 0 auto;
        background-color: #9e45ce;
        width: 70%;
        height: 2px;
      }
    }
    .divider-text {
      position: absolute;
      background-color: ${({ bgColor }) => bgColor};
      bottom: -12px;
      padding: 0 25px;
      letter-spacing: 3px;
      font-weight: 700;
      font-size: 16px;
      color: #70b97a;
    }

    @media ${device.lg} {
    }
    @media ${device.md} {
      & {
        margin-bottom: 50px;
        .divider-line-group {
          width: 100%;
          .divider-line-1 {
          }
        }
        .divider-text {
          bottom: -11px;
          font-size: 13px;
        }
      }
    }
    @media ${device.sm} {
      & {
        margin-bottom: 35px;
        .divider-line-group {
          width: 100%;
          .divider-line-1 {
            width: 100%;
          }
        }
        .divider-text {
          bottom: -9px;
          font-size: 12px;
          padding: 0 15px;
        }
      }
    }
  }
`;
